import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonPage, IonText, IonTitle, IonToolbar } from "@ionic/react";
import { logoWhatsapp } from "ionicons/icons";
import React from "react";
import ExploreContainer from "../components/ExploreContainer";
import MainTabBar from "../components/MainTabBar";
import "./MenuOnline.css";

const sendWhatsappMessage = (e: React.MouseEvent) => {
  e.preventDefault();
  window.location.href = "https://wa.me/393335889071?text=Ciao,%20vorrei%20ordinare%20";
  return null;
};

const MenuOnline: React.FC = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton></IonMenuButton>
                    </IonButtons>
                    <IonTitle>Bar Gambero</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen forceOverscroll={false}>
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">Sfoglia il Menu</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <ExploreContainer />
                <div className="ion-padding">
                    <IonButton color="success" fill="solid" size="large" expand="block" onClick={(e) => sendWhatsappMessage(e)}>
                        <IonIcon slot="start" icon={logoWhatsapp} />
                        Ordina su Whatsapp
                    </IonButton>
                    <IonText color="medium">
                        <small>
                            Specifica nome e numero del tavolo, oppure il tuo indirizzo per l'asporto. <strong>Arriveremo direttamente da voi!</strong>
                        </small>
                    </IonText>
                </div>
            </IonContent>
            <MainTabBar />
        </IonPage>
    );
};

export default MenuOnline;
